
import {
  LOGIN_URL, EMPLOYEE_LEAVE_LIST, EMPLOYEE_LEAVE_TYPE_LIST,GET_EMP_LEAVE_TYPE_BALANCE,GET_LEAVE_TYPE_LIST_BY_EMPLOYEE,
  EMPLOYEE_LEAVE_REQUEST_CANCEL,EMPLOYEE_LEAVE_REPORT_LIST,GET_REQUEST_LEAVE_COUNT,GET_APPLY_REQUEST_BY_EMPLOYEEID,LEAVE_APPROVE_CANCELED_BY_ADMIN,
  APPLY_LEAVE_EMPLOYEE, GET_APPLY_REQUEST_BY_ID,APPLY_LEAVE_AUTO_APPROVED_EMPLOYEE, GET_ALL_LEAVE_REQUEST_LIST, LEAVE_REQUEST_UPDATE,LEAVE_APPROVE_APPLY_LEAVE,GET_ALL_EMPLOYEE_BALANCE,
  GET_REQUEST_LEAVE_COUNT_WITH_SANDWICH_POLICY,
  GET_ALL_LEAVE_REQUEST_LIST_SUPERVISOR,
  LEAVE_RECONCILATION_LIST,
  APPLY_LEAVE_RECONCILATION_AUTO_APPROVED_BY_ADMINE,
  GET_LEAVE_LOP_ADJSUTMENT,
  ADD_EMPLOYEE_LEAVE_LOP_ADJUSTMENT,
  EXPORT_EMPLOYEE_LEAVE_LOP_ADJUSTMENT_DATA
} from "../Api/ApiLeaveEndPoint";

import axios, { axiosMultipart } from "../Api/axios";
import { useNavigate } from "react-router-dom";
import { axiosApiInstance } from "app/Api/axios";

export const login = async (userId, userPassword) => {
  const response = await axiosApiInstance.post(LOGIN_URL, {
    userId: userId,
    userPassword: userPassword,
  });
  return response;
};

export const getAllRequestList = async (params) => {
  return await axiosApiInstance.get(GET_ALL_LEAVE_REQUEST_LIST, {
    params: {
      ...params,
    },
  });
};


export const getAllSupervisorRequestList = async (params) => {
  return await axiosApiInstance.get(GET_ALL_LEAVE_REQUEST_LIST_SUPERVISOR, {
    params: {
      ...params,
    },
  });
};

export const getAllLopAdjustmentList = async (params) => {
  return await axiosApiInstance.get(GET_LEAVE_LOP_ADJSUTMENT, {
    params: {
      ...params,
    },
  });
};
export const exportEmployeeLOPData = async (params) => {
  return await axiosApiInstance.get(EXPORT_EMPLOYEE_LEAVE_LOP_ADJUSTMENT_DATA, {
    params: {
      ...params,
    },
  });
};
export const AddEmployeeLeaveAdjustment = async (params) => {
  return await axiosApiInstance.post(ADD_EMPLOYEE_LEAVE_LOP_ADJUSTMENT, {
    params: {
      ...params,
    },
  });
};



export const getEmployeeLeaveList = async (params) => {
  return await axiosApiInstance.get(EMPLOYEE_LEAVE_LIST, {
    params: {
      ...params,
    },
  });
};
export const getLeaveRequestCount = async (params) => {
  return await axiosApiInstance.get(GET_REQUEST_LEAVE_COUNT, {
    params: {
      ...params,
    },
  });
};
export const getLeaveRequestCountWithSandwichRule = async (params) => {
  return await axiosApiInstance.get(GET_REQUEST_LEAVE_COUNT_WITH_SANDWICH_POLICY, {
    params: {
      ...params,
    },
  });
};

export const getEmployeeLeaveTypedetails = async (params) => {
  return await axiosApiInstance.get(GET_LEAVE_TYPE_LIST_BY_EMPLOYEE, {
    params: {
      ...params,
    },
  });
};
export const getEmployeeLeaveTypeList = async (params) => {
  return await axiosApiInstance.get(EMPLOYEE_LEAVE_TYPE_LIST, {
    params: {
      ...params,
    },
  });
};
export const getEmployeeLeaveReport = async (params) => {
  return await axiosApiInstance.get(EMPLOYEE_LEAVE_REPORT_LIST, {
    params: {
      ...params,
    },
  });
};

export const cancelLeaveRequestByUser = async (params) => {
  return await axiosApiInstance.put(EMPLOYEE_LEAVE_REQUEST_CANCEL, {
    params: {
      ...params,
    },
  });
};

export const applyLeaveRequest = async (params) => {
  return await axiosApiInstance.post(APPLY_LEAVE_EMPLOYEE, params);
};
export const applyLeaveAutoApprovedRequest = async (params) => {
  return await axiosApiInstance.put(APPLY_LEAVE_AUTO_APPROVED_EMPLOYEE, params);
};
export const applyLeaveReconcilationAutoApprovedbyAdmin = async (params) => {
  return await axiosApiInstance.put(APPLY_LEAVE_RECONCILATION_AUTO_APPROVED_BY_ADMINE, params);
};

export const editLeaveRequest = async (params) => {
  return await axiosApiInstance.put(LEAVE_REQUEST_UPDATE, params);
};

export const adminAproveLeaveRequest = async (params) => {
  return await axiosApiInstance.put(LEAVE_APPROVE_APPLY_LEAVE, params);
};

export const adminAproveCanceledByAdminLeaveRequest = async (params) => {
  return await axiosApiInstance.put(LEAVE_APPROVE_CANCELED_BY_ADMIN, params);
};


export const getLeaveRequestById = async (requestId) => {
  return await axiosApiInstance.get(
    GET_APPLY_REQUEST_BY_ID + `/${requestId}`
  );
};
export const getLeaveRequestByEmployeeId = async (requestId) => {
  return await axiosApiInstance.get(
    GET_APPLY_REQUEST_BY_EMPLOYEEID + `/${requestId}`
  );
};


export const getEmployeeLeaveTypeBalance = async (LeaveTypeId) => {
  return await axiosApiInstance.get(
    GET_EMP_LEAVE_TYPE_BALANCE+`/${LeaveTypeId}`,
  );
};

export const getEmployeeLeaveBalace = async (params) => {
  return await axiosApiInstance.get(GET_ALL_EMPLOYEE_BALANCE, {
    params: {
      ...params,
    },
  });
};


// LEAVE RECONCILATION APIS

export const getLeaveReconcilationData = async (params) => {
  return await axiosApiInstance.get(LEAVE_RECONCILATION_LIST, {
    params: {
      ...params,
    },
  });
};